"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSuggestionGroup = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/scroll/scroll");
/**
 * 검색 추천 키워드 그룹. 가로 스크롤 가능한 추천어 영역.
 * 스크롤과 양 끝의 흐림·넘김 버튼은 mm-scroll(row)이 소유한다.
 *
 * <mm-search-suggestion-group aria-label="추천 검색어">
 *   <mm-search-suggestion>로얄테넌바움</mm-search-suggestion>
 *   <mm-search-suggestion>소매치기</mm-search-suggestion>
 * </mm-search-suggestion-group>
 */
let SearchSuggestionGroup = class SearchSuggestionGroup extends lit_1.LitElement {
    connectedCallback() {
        super.connectedCallback();
        this.setAttribute('role', 'group');
    }
    render() {
        return (0, lit_1.html) `
      <mm-scroll gap="2" hide-scrollbar>
        <slot></slot>
      </mm-scroll>
    `;
    }
};
SearchSuggestionGroup.styles = (0, lit_1.css) `
    :host {
      display: block;
    }

    ::slotted(mm-search-suggestion) {
      flex-shrink: 0;
    }
  `;
SearchSuggestionGroup = __decorate([
    (0, decorators_js_1.customElement)('mm-search-suggestion-group')
], SearchSuggestionGroup);
exports.SearchSuggestionGroup = SearchSuggestionGroup;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VhcmNoLXN1Z2dlc3Rpb24tZ3JvdXAuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJzZWFyY2gtc3VnZ2VzdGlvbi1ncm91cC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQWlEO0FBRWpELDZDQUEwQztBQUUxQzs7Ozs7Ozs7R0FRRztBQUVJLElBQU0scUJBQXFCLEdBQTNCLE1BQU0scUJBQXNCLFNBQVEsZ0JBQVU7SUFVbkQsaUJBQWlCO1FBQ2YsS0FBSyxDQUFDLGlCQUFpQixFQUFFLENBQUE7UUFDekIsSUFBSSxDQUFDLFlBQVksQ0FBQyxNQUFNLEVBQUUsT0FBTyxDQUFDLENBQUE7SUFDcEMsQ0FBQztJQUVELE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzs7O0tBSVYsQ0FBQTtJQUNILENBQUM7O0FBcEJNLDRCQUFNLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7O0dBUWxCLENBQUE7QUFUVSxxQkFBcUI7SUFEakMsSUFBQSw2QkFBYSxFQUFDLDRCQUE0QixDQUFDO0dBQy9CLHFCQUFxQixDQXNCakM7QUF0Qlksc0RBQXFCIn0=